<template>
  <div>
    <!--    走马灯-->
    <div class="banner">
      <el-carousel indicator-position="outside" height="420px">
        <el-carousel-item v-for="item in slides" :key="item.id">
          <a :href="item.url" target="_blank">
            <img :src="item.cover" class="banner_img" />
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="content">
      <!-- 新闻资讯 -->
      <div class="content_item">
        <div class="content_item_title" @click="gotoNewsList" style="cursor:pointer">
          <div class="content_item_title_left">
            <img src="@/assets/home/news.png" alt="新闻资讯" />
          </div>
          <div class="content_item_title_right more">
            <a>
              更多
              <i class="el-icon-d-arrow-right"></i>
            </a>
          </div>
        </div>
        <div class="news">
          <div class="news_left">
            <el-carousel>
              <el-carousel-item v-for="(item, i) in newsList" :key="i">
                <a :href="item.url" target="_blank">
                  <img :src="item.cover" :alt="item.name" class="news_img" :title="item.name" />
                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="news_right">
            <ul>
              <li v-for="(item, i) in newsList" :key="i" class="news_item" @click="gotoNewsDetail(item.newsId)"
                style="cursor:pointer">
                <!--                <span class="el-icon-chat-dot-round"></span>-->
                <span>{{ item.name }}</span>
                <span class="news_date">{{ item.date }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import requests from "@/api/request";
export default {
  name: "HomeView",
  data() {
    return {
      activityList: [],
      dataSetList: [],
      newsList: [],
      slides: [],
    };
  },
  mounted() {
    this.getActivityList(1, 3);
    this.getNewsList(1, 5);
    this.getdataSetList(1, 7);
    this.getSlides();
  },
  methods: {
    // 学术活动数据
    async getActivityList(page, pageSize) {
      return requests({
        url: "/activities/showActivities?page=" + page + "&pageSize=" + pageSize,
        method: "GET"
      }).then(res => {
        console.log('getActivityList', res);
        let d = res.data.items;
        d.forEach((item, i) => {
          this.activityList.push(d[i]);
          this.$set(this.activityList[i], 'year', d[i].time.substring(0, 4).replace(/-/g, "/"));
          this.$set(this.activityList[i], 'datetime', d[i].time.substring(5, 10).replace(/-/g, "/"));
        });
        // console.log('this.activityList',this.activityList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
    // 学术活动点击更多
    gotoActivityList() {
      this.$router.push({
        path: '/activity/list'
      }).catch(err => { })
    },
    // 学术活动 跳转详情
    gotoActivityDetail(activitiesId) {
      this.$router.push({ name: 'activityDeatil', query: { activitiesId: activitiesId } })
    },

    // 轮播图数据
    async getSlides() {
      return requests({
        url: "/slides/showSlides",
        method: "GET"
      }).then(res => {
        console.log('getSlides', res);
        this.slides = res.data;
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },

    // 数据集 数据
    async getdataSetList(page, pageSize) {
      return requests({
        url: "/products/showProductPages?page=" + page + "&pageSize=" + pageSize,
        method: "GET"
      }).then(res => {
        console.log('getdataSetList', res);
        let d = res.data.items;
        d.forEach((item, i) => {
          this.dataSetList.push(d[i]);
          this.$set(this.dataSetList[i], 'date', d[i].createTime.substring(0, 11).replace(/-/g, "/"));
          // this.$set(this.dataSetList[i], 'datetime', d[i].time.substring(5,10).replace(/-/g, "/"));
        });
        // console.log('this.activityList',this.activityList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
    // 数据集 点击更多
    gotoPlatformList() {
      this.$router.push({
        path: '/platform/list'
      }).catch(err => { })
    },
    // 数据集 跳转详情
    gotoPlatformDetail(platformId) {
      this.$router.push({ name: 'platformDetail', query: { platformId: platformId } })
    },

    // 新闻资讯数据
    async getNewsList(page, pageSize) {
      return requests({
        url: "/news/showNewsPages?page=" + page + "&pageSize=" + pageSize,
        method: "GET"
      }).then(res => {
        console.log('getNewsList', res);
        let d = res.data.items;
        d.forEach((item, i) => {
          this.newsList.push(d[i]);
          this.$set(this.newsList[i], 'date', d[i].createTime.substring(0, 12));
        });
        console.log('this.newsList', this.newsList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
    // 新闻资讯点击更多
    gotoNewsList() {
      this.$router.push({
        path: '/news/list'
      }).catch(err => { })
    },
    // 新闻资讯 跳转详情
    gotoNewsDetail(newsId) {
      this.$router.push({ name: 'newsDetail', query: { newsId: newsId } })
    }
  }
};
</script>

<style scoped>
.banner {
  padding: 10px 0;
}

.banner_img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.content_item {
  padding: 30px 0;
}

.content_item_flex {
  display: flex;
  justify-content: space-between;
}

.content_item_content {
  width: 48%;
}

.content_item_title {
  width: 100%;
}

.content_item_title_left {
  float: left;
}

.content_item_title_right {
  float: right;
}

.activity,
.news,
.dataset {
  padding: 10px 0;
  clear: both;
}

ul {
  margin: 0;
}

li {
  list-style: none;
}

.activity_item {
  width: 100%;
  height: 120px;
  display: flex;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: solid 1px #e9ecf3;
}

.activity {
  padding-top: 30px;
}

.activity_left {
  width: 80px;
  height: 80px;
  background-color: #2e6590;
  border-radius: 50%;
  text-align: center;
  color: white;
}

.activity_left .date_top {
  margin-top: 15px;
  font-size: 24px;
}

.activity_left .date_bottom {
  font-size: 16px;
}

.activity_right {
  width: 420px;
  height: 80px;
  padding: 0 20px;
  line-height: 26px;
  text-align: left;
}

.activity_right p {
  margin: 0;
}

.activity_title {
  font-size: 18px;
}

.activity_text {
  color: #777;
  line-height: 22px;
  font-size: 14px;
}

.dataset_table>>>td {
  padding: 0;
  font-size: 12px;
}

.dataset_title_collapse_item {
  background: none;
  margin: 0 0 -1px 0;
}

.dataset_title_collapse_item>>>.el-collapse-item__header {
  background: none;
  margin-left: 20px;
  font-size: 16px;
}

.dataset_title_collapse_item>>>.el-collapse-item__wrap {
  background: none;
  padding: 0 20px;
}

.news {
  display: flex;
}

.news_left {
  width: 400px;
}

.news_img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.news_right {
  width: 800px;
  //background-color: #42b983;
}

.news_item {
  height: 55px;
  font-size: 16px;
  text-align: left;
  //text-align: center;
  //padding-left: -20px;
  line-height: 55px;
  border-bottom: 1px black dashed;
}

.news li::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #6a005f;
  margin: 25px 10px 0 20px;
}

.news_date {
  float: right;
  width: 100px;
  display: inline-block;
}
</style>
